// @ts-nocheck
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/**
 *
 * UpfrontTdrDetails
 *
 */

import React, { useState, memo, useEffect, useContext } from 'react';
// import PropTypes from 'prop-types';
import {
  Text,
  Space,
  Popup,
  Toggle,
  Conditional,
  EllipsisPopup,
  Icon,
} from '@cashfree-intl/coherent';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { compose } from 'redux';

import { useNavigate, useSearchParams } from 'react-router-dom';

import Loader from 'components/Loader';

import { useInjectSaga } from 'utils/injectSaga';
import { useInjectReducer } from 'utils/injectReducer';
import Analytics from 'utils/analytics';
import {
  CURRENCY_SYMBOL,
  PGDB_ENABLE_UPFRONT_TDR_SLABS_FOR_ALL,
  PGDB_SHOW_UPFRONT_TDR_SLABS,
  PLACEHOLDER_TEXT,
} from 'utils/constants';
import { scrollToTop, getItemFromLocalStorage, titleCase } from 'utils/common';
import moment from 'moment';
import makeSelectUpfrontTdrDetails from './selectors';
import reducer from './reducer';
import saga from './saga';
// import { findPaymenGateways } from './helpers';

import { Option, IUpfrontTdrDetailsProps } from './types';

import {
  getPaymentMethodsAction,
  enableLoaderAction,
  disableLoaderAction,
  getActiveGatewaysAction,
  resetPageAction,
  resetFiltersAction,
  updateFiltersAction,
  saveUpfrontTDRAction,
  updateUpfrontTDRAction,
  getUpfrontTDRPerPaymentMethods as getUpfrontTDRPerPaymentMethodsAction,
} from './actions';

import TDRFormWrapper from './components/TDRFormWrapper';
import TDRListPerPaymentMethod from './components/TDRListPerPaymentMethod';
import {
  CUSTOM_FIELDS,
  EDIT_TDR,
  GREATER_THAN,
  GREATER_THAN_VALUE,
  LESS_THAN_EQUALS_TO,
  LESS_THAN_EQUALS_TO_VALUE,
  PAYMENT_METHOD_RATES_ACTIONS,
  TDR_TYPE,
} from './constants';
import ExternalPMRForm from './components/ExternalPMRForm';

import { MerchantContext } from '../../contexts/MerchantContext';
import { filterFormData, findPaymenGateways } from './helpers';
import { StyledTableCTAItem } from './components/styled';

export function UpfrontTdrDetails({
  enableLoader,
  disableLoader,
  getActiveGateways,
  getPaymentMethods,
  resetPage,
  resetFilters,
  updateFilters,
  saveUpfrontTDR,
  upfrontTdrDetails,
  updateUpfrontTDR,
  getUpfrontTDRPerPaymentMethods,
}: IUpfrontTdrDetailsProps) {
  useInjectReducer({ key: 'upfrontTdrDetails', reducer });
  useInjectSaga({ key: 'upfrontTdrDetails', saga, mode: '' });

  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const { featureToggles = {} } = useContext(MerchantContext);

  const [formData, setFormData] = useState<any[]>([]);
  const [paymentMethods, setPaymentMethods] = useState<Option[]>([]);
  const [gateways, setGateways] = useState<any[]>([]);
  const [rowData, setRowData] = useState([]);
  const [totalPages, setTotalPages] = useState(0);
  const [totalCount, setTotalCount] = useState(0);

  const [selectedRowData, setSelectedRowData] = useState<any[]>([]);
  const [isExternalPMRFormOpen, setExternalPMRFormOpen] = useState(false);
  const [externalPMRFormData, setExternalPMRFormData] = useState<{ data?: any, slabIndex?: number }>({});

  const { paymentMode = '', env = '' } = Object.fromEntries(searchParams);

  const showSlabs = PGDB_SHOW_UPFRONT_TDR_SLABS in featureToggles &&
    featureToggles[PGDB_SHOW_UPFRONT_TDR_SLABS];

  const enableSlabsForAll = PGDB_ENABLE_UPFRONT_TDR_SLABS_FOR_ALL in featureToggles &&
    featureToggles[PGDB_ENABLE_UPFRONT_TDR_SLABS_FOR_ALL];

  const { isLoading, filtersForDisplay, filters = {} } = upfrontTdrDetails;

  const navigateBack = () => navigate(-1);

  const getTableData = (fetchGateways: boolean = false) => {
    const { pageNo, pageSize, appliedFilters } = filters;
    const { startDate, endDate, status } = appliedFilters;

    const payload = {
      groupName: paymentMode,
      startDate: moment(startDate).format('YYYY-MM-DD'),
      endDate: moment(endDate).format('YYYY-MM-DD'),
      page: pageNo,
      pageSize,
      // status: 'ACTIVE',
    };
    // get api call
    getUpfrontTDRPerPaymentMethods({
      payload,
      status,
      fetchGateways,
      cb: response => {
        const [tdrResponse, gateways] = response;

        if (fetchGateways) {
          setGateways(gateways);
        }

        const { totalItems, totalPages: pages, data = [] } = tdrResponse;
        const result = formatTableData(data || [], fetchGateways ? gateways : []);
        setRowData(result);
        // totalItems -> totalCount
        // totalPages -> totalPages
        setTotalCount(totalItems);
        setTotalPages(pages);

        disableLoader();
      },
    });
  };

  const onTDRFormSubmit = (payload: any, actions: any) => {
    enableLoader();

    const defaultValue = {
      tdr: '',
      pg: '',
      floor: '',
      ceil: '',
      fixedFee: '',
      externalUpfrontTdrType: TDR_TYPE.FLAT,
      paymentMethod: [],
      paymentNetwork: [],
    };

    // we can check here if - edit mode or normal mode
    // if edit mode then - individual update or group update
    if (formData.length === 1) {
      // prepare the payload here for individual update
      const { tdr, tdrType, pg, floor, ceil, fixedFee } = payload[0];

      let requestPayload = {
        merchantId: +getItemFromLocalStorage('merchantId'),
        externalUpfrontTdr: +tdr,
        externalUpfrontTdrType: tdrType,
        pg: formData[0].pg || '',
        isActive: formData[0].isActive,
      };

      if (showSlabs) {
        const [filteredFormData] = filterFormData(formData);

        requestPayload = {
          ...filteredFormData,
          merchantId: +getItemFromLocalStorage('merchantId'),
          externalUpfrontTdr: +tdr,
          externalUpfrontTdrType: tdrType,
          merchantExternalPMRConditionRequest: null,
          pg,
          floor: +floor,
          ceil: +ceil,
          fixedFee: +fixedFee,
        };

        delete requestPayload.merchantExternalPMRConditions;

      }
      // make the api call here for updating the individual tdr
      // enableLoader();
      updateUpfrontTDR({
        modeCode: formData[0].code,
        payload: requestPayload,
        cb: () => {
          // we can optimise this by updating the isActive of that particular record
          actions.resetForm({
            values: defaultValue,
          });
          getTableData();
          setFormData([]);
        },
      });
    } else if (formData.length > 1) {
      const { tdr, tdrType, floor, ceil, fixedFee } = payload[0];
      // use this tdr for all the existing form data and make the api call for saveupfront tdr
      const requestPayload = filterFormData(formData).map(obj => {

        let tdrPayload = {
          merchantId: +getItemFromLocalStorage('merchantId'),
          modeCode: obj.code,
          externalUpfrontTdr: +tdr,
          externalUpfrontTdrType: tdrType,
          pg: obj.pg || '',
          isActive: obj.isActive,
        };

        if (showSlabs) {
          // clone the existing values and override only the ones which are editable
          tdrPayload = {
            ...obj,
            merchantId: +getItemFromLocalStorage('merchantId'),
            modeCode: obj.code,
            externalUpfrontTdr: +tdr,
            externalUpfrontTdrType: tdrType,
            pg: obj.pg || '',
            merchantExternalPMRConditionRequest: null,
            floor: +floor,
            ceil: +ceil,
            fixedFee: +fixedFee,
          };

          delete tdrPayload.merchantExternalPMRConditions;
          delete tdrPayload.code;

        }
        return tdrPayload;
      });

      // for group update
      saveUpfrontTDR({
        payload: requestPayload,
        cb: () => {
          actions.resetForm({
            values: defaultValue,
          });
          getTableData();
          setFormData([]);
        },
      });
    } else {
      saveUpfrontTDR({
        payload,
        cb: () => {
          actions.resetForm({
            values: defaultValue,
          });
          getTableData();
          if (formData.length > 0) setFormData([]);
        },
      });
    }
  };

  const onToggleClick = obj => e => {
    e.stopPropagation();

    const isActive = !obj.isActive;

    const filteredObject = showSlabs ? Object.keys(obj).reduce((acc, key) => {
      if (!CUSTOM_FIELDS.includes(key)) {
        acc[key] = obj[key];
      }
      return acc;
    }, {}) : { pg: obj.pg || '' };

    const payload = {
      ...filteredObject,
      merchantId: +getItemFromLocalStorage('merchantId'),
      externalUpfrontTdr: +obj.UpfrontTdr,
      externalUpfrontTdrType: obj.upfrontTdrType,
      merchantExternalPMRConditionRequest: null,
      isActive,
    };

    delete payload.merchantExternalPMRConditions;

    // make the api call here for updating the individual tdr
    enableLoader();
    updateUpfrontTDR({
      modeCode: obj.code,
      payload,
      cb: getTableData,
    });
    Analytics.trackEventWithNewNomenclature({
      eventName: 'Table_Row_Toggle',
      eventProperties: {
        row_id: `${obj.display}-${obj.code}`,
      },
    });
  };

  const onEditClick = (obj, id) => {
    // make sure to highlight the row
    // console.log('clicked on edit');
    setFormData([{ ...obj, id }]);
    scrollToTop('.children-wrapper');
  };

  const onActionsClick = row => (e, itemSelected) => {
    e.stopPropagation();

    if (itemSelected === EDIT_TDR) {
      onEditClick(row, `${row.display}-${row.code}`);
    } else {
      setExternalPMRFormOpen(true);
      setSelectedRowData([row]);
    }

    Analytics.trackEventWithNewNomenclature({
      eventName: `Table_Row_EllipsisPopup_${itemSelected}`,
      eventProperties: {
        row_id: `${row.display}-${row.code}`,
      },
    });
  };

  const onExternalFormSubmit = (values, actions) => {
    const [payload] = filterFormData(selectedRowData);
    const { externalPMR: externalPMRData } = values;

    const externalPMR = externalPMRData.map(obj => {
      const { condition, ...rest } = obj;
      return Object.keys(rest).reduce((acc, key) => {
        if ((key === GREATER_THAN_VALUE && condition === LESS_THAN_EQUALS_TO) ||
          (key === LESS_THAN_EQUALS_TO_VALUE && condition === GREATER_THAN)) {
          acc[key] = null;
        } else if (rest[key]) {
          acc[key] = rest[key];
        } else {
          acc[key] = [GREATER_THAN_VALUE, LESS_THAN_EQUALS_TO_VALUE].includes(key) ? null : 0;
        }
        return acc;
      }, {});
    });

    const externalPMRConditions = payload.merchantExternalPMRConditions;
    delete payload.merchantExternalPMRConditions;

    // adding externalUpfrontTdr and merchantId to the payload
    payload.externalUpfrontTdr = +payload.UpfrontTdr;
    payload.externalUpfrontTdrType = payload.upfrontTdrType;
    payload.merchantId = +getItemFromLocalStorage('merchantId');

    // in case of update externalPMRFormData will have slabIndex and data
    const { data, slabIndex } = externalPMRFormData;

    if (data) {
      const [newSlabData] = externalPMR;
      const oldSlabData = externalPMRConditions[slabIndex];
      // sending only the data which has changed
      payload.merchantExternalPMRConditionRequest = [{
        ...oldSlabData,
        ...newSlabData,
      }];
    } else {
      // only send the newly added form data
      payload.merchantExternalPMRConditionRequest = [];

      externalPMR.forEach(obj => {
        payload.merchantExternalPMRConditionRequest.push({
          ...obj,
          active: true,
        });
      });
    }

    enableLoader();

    updateUpfrontTDR({
      modeCode: selectedRowData[0].code,
      payload,
      cb: () => {
        setExternalPMRFormOpen(false);
        setSelectedRowData([]);
        setExternalPMRFormData({});
        getTableData();
      },
      errorCb: () => actions.setSubmitting(false),
    });
  };

  const onExternalPMRToggle = (row, slabIndex) => () => {
    const [payload] = filterFormData([row]);

    const slabData = payload.merchantExternalPMRConditions[slabIndex];

    // passing only the record which has been updated
    payload.merchantExternalPMRConditionRequest = [{ ...slabData, active: !slabData.active }];

    // adding externalUpfrontTdr and merchantId to the payload
    payload.externalUpfrontTdr = +payload.UpfrontTdr;
    payload.externalUpfrontTdrType = payload.upfrontTdrType;
    payload.merchantId = +getItemFromLocalStorage('merchantId');

    delete payload.merchantExternalPMRConditions;

    enableLoader();
    updateUpfrontTDR({
      modeCode: row.code,
      payload,
      cb: getTableData,
    });

    Analytics.trackEventWithNewNomenclature({
      eventName: 'ExternalPMRTable_Row_Toggle',
      eventProperties: {
        row_id: `${obj.display}-${obj.code}`,
      },
    });
  };

  const onExternalPMREdit = (row, slabIndex) => () => {
    setSelectedRowData([row]);
    setExternalPMRFormData({ data: row.merchantExternalPMRConditions[slabIndex], slabIndex });
    setExternalPMRFormOpen(true);
  };

  const formatTableData = (response: any, gatewaysList: any[]) => {
    const gatewayArr = gatewaysList && gatewaysList.length > 0 ? gatewaysList : gateways;
    const result = response.map((obj: any) => ({
      // see if the combination of code and gateways is unique
      id: `${obj.merchantId}-${obj.code}-${obj.pg || ''}`,
      ...obj,
      addedOn: moment(obj.addedOn).format('DD MMM YYYY'),
      updatedOn: moment(obj.updatedOn).format('DD MMM YYYY'),
      banks: obj.display || PLACEHOLDER_TEXT,
      gateway: showSlabs
        ? findPaymenGateways(obj.pg, gatewayArr) || obj.pg || PLACEHOLDER_TEXT
        : null,
      status: () => (
        <Text variant="b14" color={obj.isActive ? 'success' : 'bodyLight'}>
          {obj.isActive ? 'Active' : 'Inactive'}
        </Text>
      ),
      floorValue: () => (
        <>
          <Conditional if={obj.floor}>
            <Text variant="h16">
              {CURRENCY_SYMBOL.INR}
              {obj.floor}
            </Text>
          </Conditional>
          <Conditional if={!obj.floor}>{PLACEHOLDER_TEXT}</Conditional>
        </>
      ),
      ceilValue: () => (
        <>
          <Conditional if={obj.ceil}>
            <Text variant="h16">
              {CURRENCY_SYMBOL.INR}
              {obj.ceil}
            </Text>
          </Conditional>
          <Conditional if={!obj.ceil}>{PLACEHOLDER_TEXT}</Conditional>
        </>
      ),
      fixedFeeValue: () => (
        <>
          <Conditional if={obj.fixedFee}>
            <Text variant="h16">
              {CURRENCY_SYMBOL.INR}
              {obj.fixedFee}
            </Text>
          </Conditional>
          <Conditional if={!obj.fixedFee}>{PLACEHOLDER_TEXT}</Conditional>
        </>
      ),
      upfrontTdr: () => (
        <>
          <Conditional if={obj.UpfrontTdr}>
            <Text variant="h16">
              {obj.upfrontTdrType === TDR_TYPE.FLAT ? CURRENCY_SYMBOL.INR : ''}
              {obj.UpfrontTdr}
              {obj.upfrontTdrType === TDR_TYPE.PERCENTAGE ? '%' : ''}
            </Text>
          </Conditional>
          <Conditional if={!obj.UpfrontTdr}>{PLACEHOLDER_TEXT}</Conditional>
        </>
      ),
      toggle: () => (
        <Space alignItems="center" gap={0.75}>
          <Popup
            content={obj.isActive ? 'Disable TDR' : 'Enable TDR'}
            position="bottom right"
            trigger={
              <span>
                <Toggle
                  active={obj.isActive}
                  onToggle={onToggleClick(obj)}
                  data-event-name="Table_Row_Toggle"
                  data-ignore-inner-text="true"
                  data-event-properties={JSON.stringify({
                    row_id: `${obj.display}-${obj.code}`,
                  })}
                />
              </span>
            }
          />
          <Text variant="b12" color="bodyLight">
            {obj.isActive ? 'ON' : 'OFF'}
          </Text>
        </Space>
      ),
      edit: () =>
        !showSlabs && (
          <StyledTableCTAItem
            className="table-cta-item"
            onClick={() => onEditClick(obj, `${obj.display}-${obj.code}`)}
            data-event-name="Table_Row_EditUpfrontTDR"
            data-ignore-inner-text="true"
            data-event-properties={JSON.stringify({
              row_id: `${obj.display}-${obj.code}`,
            })}
          >
            <Icon name="edit" />
          </StyledTableCTAItem>
        ),
      actions: () =>
        showSlabs && (
          <EllipsisPopup
            menuItems={PAYMENT_METHOD_RATES_ACTIONS.map(item => ({
              ...item,
              image: () => <Icon name={item.key} />,
            }))}
            onClick={onActionsClick(obj)}
            data-event-name="Table_Row_EllipsisPopup"
            data-ignore-inner-text="true"
            data-event-properties={JSON.stringify({
              row_id: `${obj.display}-${obj.code}`,
            })}
          />
        ),
    }));
    return result;
  };

  useEffect(() => {
    setTimeout(() => {
      enableLoader();
      getTableData(!!showSlabs);
    }, 0);
  }, [filters, env]);

  useEffect(
    () => () => {
      resetFilters();
      setFormData([]);
    },
    [],
  );

  return (
    <div>
      <Loader active={isLoading} />
      <div className="mb-4">
        <Text variant="h20" className="mb-1">
          Upfront TDRs for {titleCase(paymentMode)}
        </Text>
        <Text variant="b14" color="bodyLight">
          Add and manage Upfront TDR to your customers for{' '}
          {titleCase(paymentMode)} and manage them here.
        </Text>
      </div>
      <TDRFormWrapper
        formData={formData}
        gateways={gateways}
        setFormData={setFormData}
        paymentMode={paymentMode}
        navigateBack={navigateBack}
        paymentMethods={paymentMethods}
        setPaymentMethods={setPaymentMethods}
        saveUpfrontTDR={onTDRFormSubmit}
        getPaymentMethods={getPaymentMethods}
        showSlabs={!!showSlabs}
        enableSlabsForAll={enableSlabsForAll}
      />
      <TDRListPerPaymentMethod
        filters={filters}
        filtersForDisplay={filtersForDisplay}
        paymentMode={paymentMode}
        enableLoader={enableLoader}
        disableLoader={disableLoader}
        resetPage={resetPage}
        paymentMethods={paymentMethods}
        resetFilters={resetFilters}
        updateFilters={updateFilters}
        setFormData={setFormData}
        formData={formData}
        rowData={rowData}
        totalCount={totalCount}
        totalPages={totalPages}
        onExternalPMRToggle={onExternalPMRToggle}
        onExternalPMREdit={onExternalPMREdit}
        showSlabs={!!showSlabs}
        isLoading= {isLoading}
      />
      <Conditional if={isExternalPMRFormOpen}>
        <ExternalPMRForm
          initialValues={
            Object.keys(externalPMRFormData)?.length > 0 ? externalPMRFormData.data : {}
          }
          closeModal={() => {
            setExternalPMRFormOpen(false);
            setExternalPMRFormData({});
            setSelectedRowData([]);
          }}
          onSubmit={onExternalFormSubmit}
        />
      </Conditional>
    </div>
  );
}

UpfrontTdrDetails.propTypes = {};

const mapStateToProps = createStructuredSelector({
  upfrontTdrDetails: makeSelectUpfrontTdrDetails(),
});

function mapDispatchToProps(dispatch) {
  return {
    enableLoader: () => dispatch(enableLoaderAction()),
    disableLoader: () => dispatch(disableLoaderAction()),
    getPaymentMethods: data => dispatch(getPaymentMethodsAction(data)),
    getActiveGateways: data => dispatch(getActiveGatewaysAction(data)),
    resetFilters: () => dispatch(resetFiltersAction()),
    updateFilters: data => dispatch(updateFiltersAction(data)),
    resetPage: () => dispatch(resetPageAction()),
    getUpfrontTDRPerPaymentMethods: data =>
      dispatch(getUpfrontTDRPerPaymentMethodsAction(data)),
    saveUpfrontTDR: data => dispatch(saveUpfrontTDRAction(data)),
    updateUpfrontTDR: data => dispatch(updateUpfrontTDRAction(data)),
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export default compose(
  withConnect,
  memo,
)(UpfrontTdrDetails);
